export default "<div class=\"widget\">\n    <app-assignee-profile [assignee]=\"assignee\"></app-assignee-profile>\n</div>\n"